import { render, staticRenderFns } from "./KoioteNumericKeyboard.vue?vue&type=template&id=4bd5f5fc"
import script from "./KoioteNumericKeyboard.vue?vue&type=script&lang=js"
export * from "./KoioteNumericKeyboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports